import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"
import { InstrumentDetail } from "../types"

const useUpdateTradingInstrumentMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (instrument: InstrumentDetail) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  return useMutation(scientApi.trading.updateTradingInstrument, { onSuccess, onError })
}

export default useUpdateTradingInstrumentMutation
